module.exports = __webpack_public_path__ + "assets/img/2icon.2fe97d2b.png";